/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as Msdyn365 from '@msdyn365-commerce/core';
import { getUrlSync } from '@msdyn365-commerce/core';
import {
    Button,
    // format,
    getPayloadObject,
    getTelemetryAttributes,
    ITelemetryContent,
    onTelemetryClick,
    UncontrolledTooltip
} from '@msdyn365-commerce-modules/utilities';
import { observer } from 'mobx-react';
import * as React from 'react';

export interface IWishListIconProps {
    context: any;
    id: any;
    className?: string;
    wishlistTooltipText: string;
    showButtonTooltip?: boolean;
    telemetryContent?: ITelemetryContent;
    wishlistCountLabel?: string;
    wishlistCount?: number;
    isDispayWishlistCount?: boolean;
}

/**
 *
 * WishListIcon component.
 * @extends {React.PureComponent<IWishListIconProps>}
 */

@observer
export class WishListIcon extends React.PureComponent<IWishListIconProps> {
    private readonly attributes?: Msdyn365.IDictionary<string>;

    constructor(props: IWishListIconProps) {
        super(props);
        const text = props.wishlistTooltipText;

        // Construct telemetry attribute to render
        const payLoad = getPayloadObject('click', props.telemetryContent!, text, '');
        this.attributes = getTelemetryAttributes(props.telemetryContent!, payLoad);
    }

    public render(): JSX.Element {
        const wishlistIconRef: React.RefObject<HTMLButtonElement> = React.createRef();
        const payLoad = getPayloadObject('click', this.props.telemetryContent!, this.props.wishlistTooltipText, '');
        const showButtonIconTooltip = this.props.showButtonTooltip;
        const wishlistUrl = getUrlSync('wishlist', this.props.context.actionContext);
        const signInUrl = `${this.props.context.request.user.signInUrl}?ru=${wishlistUrl}`;
        const url = this.props.context.request.user.isAuthenticated ? wishlistUrl : signInUrl;
        const showTooltip = showButtonIconTooltip !== undefined ? showButtonIconTooltip : true;
        // const shouldShowCount = this.props.isDispayWishlistCount !== undefined ? this.props.isDispayWishlistCount : false;
        // const wishlistCountlbl = this.props.wishlistCountLabel !== undefined ? this.props.wishlistCountLabel : '';
        // const wishlistItemCount = this.props.wishlistCount !== undefined ? this.props.wishlistCount : '';
        // const countLabel = format(wishlistCountlbl, wishlistItemCount);
        return (
            <>
                <Button
                    className='ms-wishlist-new'
                    href={url}
                    {...this.attributes}
                    onClick={onTelemetryClick(this.props.telemetryContent!, payLoad, this.props.wishlistTooltipText)}
                >
                    {/* {shouldShowCount && <div className='msc-wishlist-icon__count'>{countLabel}</div>} */}
                    <span className='ms-wishlist-text-new'>Favorites</span>
                    <img
                        className='ms-wishlist-icon-new'
                        src='https://files-eu-prod.cms.commerce.dynamics.com/cms/api/vnnhvggtsx/binary/MD3dt'
                    ></img>
                </Button>
                {showTooltip && (
                    <UncontrolledTooltip trigger='hover focus' target={wishlistIconRef}>
                        {this.props.wishlistTooltipText}
                    </UncontrolledTooltip>
                )}
            </>
        );
    }
}
